// extracted by mini-css-extract-plugin
module.exports = {"newsCardWrapper":"newsCard_newsCardWrapper__NAeDH","membersBadge":"newsCard_membersBadge__ch9Ti","newsCard":"newsCard_newsCard__KDFxl"};